import PropTypes from "prop-types";
import styles from "./Label.css";

const Label = props => {
  const labelValue = props.formatLabel
    ? props.formatLabel(props.children, props.type)
    : props.children;

  return (
    <span
      className={styles.label}
      style={props.labelStyle}
      data-testid={props.testid}
    >
      {labelValue}
    </span>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  formatLabel: PropTypes.func,
  type: PropTypes.string.isRequired,
  labelStyle: PropTypes.objectOf(PropTypes.string),
  testid: PropTypes.string.isRequired
};

export default Label;
